export default __webpack_public_path__ + "static/media/Settings.575bc01e.jpg";